export default __webpack_public_path__ + "static/media/wix.477dbac8.svg";